import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {  APP_FILE_EQUIPMENT_LIST, APP_FILE_MANAGE_EQUIPMENT } from "./Equipment.constants";

const EquipmentList = Loadable(
  lazy(() =>
    import("./EquipmentList").then(({ EquipmentList }) => ({
      default: EquipmentList,
    }))
  )
);

const ManageEquipment = Loadable(
  lazy(() =>
    import("./ManageEquipment").then(
      ({ ManageEquipment }) => ({
        default: ManageEquipment,
      })
    )
  )
);

export const equipmentRoutes = [
 {
         path: `${APP_FILE_EQUIPMENT_LIST}/`,
         exact: true,
         element: (
           <AuthorizedRoute moduleKeys={[MODULE_IDS.COMPANY_EQUIPMENT]}>
             <EquipmentList />
           </AuthorizedRoute>
         ),
       },
 
       {
         path:`${APP_FILE_MANAGE_EQUIPMENT}`,
         exact: true,
         element: (
           <AuthorizedRoute moduleKeys={[MODULE_IDS.COMPANY_EQUIPMENT]}>
             <ManageEquipment />
           </AuthorizedRoute>
         ),
       },
 
       {
         path: `${APP_FILE_MANAGE_EQUIPMENT}/:equipmentId`,
         exact: true,
         element: (
           <AuthorizedRoute moduleKeys={[MODULE_IDS.COMPANY_EQUIPMENT]}>
             <ManageEquipment />
           </AuthorizedRoute>
         ),
       },
 
];
